import React from 'react';
import Icon from '../../../components/AppIcon';

const AIRetentionInsights = ({ insights, loading }) => {
  if (loading) {
    return (
      <div className="card">
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
        </div>
      </div>
    );
  }

  const metrics = insights?.engagementMetrics;

  const getHealthColor = (health) => {
    const healthLower = health?.toLowerCase();
    if (healthLower?.includes('excellent') || healthLower?.includes('good')) return 'text-success';
    if (healthLower?.includes('fair') || healthLower?.includes('moderate')) return 'text-warning';
    return 'text-error';
  };

  const getHealthBg = (health) => {
    const healthLower = health?.toLowerCase();
    if (healthLower?.includes('excellent') || healthLower?.includes('good')) return 'bg-success/10';
    if (healthLower?.includes('fair') || healthLower?.includes('moderate')) return 'bg-warning/10';
    return 'bg-error/10';
  };

  return (
    <div className="card border-l-4 border-l-accent">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center">
          <Icon name="Sparkles" size={20} color="var(--color-accent)" />
        </div>
        <div>
          <h3 className="text-xl font-heading font-semibold text-foreground">
            AI Insights
          </h3>
          <p className="text-sm text-muted-foreground">Powered by OpenAI</p>
        </div>
      </div>

      {!metrics ? (
        <div className="text-center py-8">
          <Icon name="Brain" size={48} color="var(--color-accent)" className="mx-auto mb-3" />
          <p className="text-muted-foreground">Click "Refresh AI Insights" to generate analysis</p>
        </div>
      ) : (
        <div className="space-y-6">
          {/* Overall Health */}
          <div className={`rounded-lg p-4 ${getHealthBg(metrics?.overallHealth)}`}>
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Activity" size={18} color="var(--color-accent)" />
              <p className="text-sm font-medium text-foreground">Overall Health</p>
            </div>
            <p className={`text-2xl font-bold ${getHealthColor(metrics?.overallHealth)}`}>
              {metrics?.overallHealth}
            </p>
          </div>

          {/* Key Findings */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Icon name="Search" size={18} color="var(--color-accent)" />
              <h4 className="font-semibold text-foreground">Key Findings</h4>
            </div>
            <ul className="space-y-2">
              {metrics?.keyFindings?.map((finding, index) => (
                <li key={index} className="flex items-start gap-2 text-sm text-muted-foreground">
                  <Icon name="CheckCircle" size={16} color="var(--color-accent)" className="mt-0.5 flex-shrink-0" />
                  <span>{finding}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Recommendations */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <Icon name="Lightbulb" size={18} color="var(--color-accent)" />
              <h4 className="font-semibold text-foreground">Recommendations</h4>
            </div>
            <ul className="space-y-2">
              {metrics?.recommendations?.map((rec, index) => (
                <li key={index} className="flex items-start gap-2 text-sm text-muted-foreground">
                  <Icon name="ArrowRight" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
                  <span>{rec}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default AIRetentionInsights;